import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormTextarea } from "src/core/components/custom-ui/form-textarea";
import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { useRenvoiCompletion } from "src/core/hooks/folder/useRenvoiCompletion";

type RenvoiCompletionModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};
export default function RenvoiCompletionModal({ open, setOpen }: RenvoiCompletionModalProps) {
  const { t } = useTranslation();
  const { form, onSubmit, isLoading, handleCancel } = useRenvoiCompletion(setOpen);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent hideCloseButton>
        <DialogHeader>
          <DialogTitle>{t("folder.renvoi.title")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("folder.renvoi.description")}
          </DialogDescription>
        </DialogHeader>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FormTextarea
              name="motifRenvoi"
              label={t("folder.renvoi.motifLabel")}
              control={form.control}
              required
            />
            <DialogFooter>
              <Button type="submit" variant="default" className="ml-[20px]" loading={isLoading}>
                {t("folder.renvoi.confirm")}
              </Button>
              <Button variant="link" onClick={handleCancel} disabled={isLoading}>
                {t("global.form.cancel")}
              </Button>
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
